import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgArrowRightBold = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 7 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="m1 11 5-5-5-5"
      stroke="#000"
      strokeWidth={1.5}
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const Memo = memo(SvgArrowRightBold);
export default Memo;
